import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled, { css } from 'styled-components';
import { marginAttributes, propsBlocker } from '../../../system';

var getRootBaseStyle = function getRootBaseStyle(_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.FormFieldMessage.Root.base;
};

var getRootDynamicStyle = function getRootDynamicStyle(_ref2) {
  var theme = _ref2.theme,
      error = _ref2.error,
      oneLine = _ref2.oneLine;
  var FormFieldMessage = theme.componentOverrides.FormFieldMessage;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", ";\n        ", ";\n    "])), oneLine ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                  white-space: nowrap;\n                  overflow-x: hidden;\n                  text-overflow: ellipsis;\n              "]))) : '', error ? FormFieldMessage.Root.error : '');
};

export var FormFieldMessageRoot = styled.div.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n\n    ", ";\n    ", ";\n    ", ";\n"])), getRootBaseStyle, getRootDynamicStyle, marginAttributes);
export var FormFieldMessageFakeChildren = styled.div.withConfig(propsBlocker)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    opacity: 0;\n    &:before {\n        content: '1';\n    }\n"])));